// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"PriceEdit_pageHeader__36iyn","priceList":"PriceEdit_priceList__1hGJD"};